<template src="./products.html"></template>

<script>
import CannotFindButton from '../../modules/cannot-find-button/cannot-find-button';

export default {
    name: 'products',
    components: {CannotFindButton},
    data () {
      return {
          products: [],
          reviews: [],
          errors: []
      }
    },

    methods: {
        moveCarousel(event) {
            let currentPosition = event.currentTarget.getAttribute('data-order');
            let movePosition = 3 - currentPosition;
            let totalReviewsNo = this.reviews.length;

            for (let i = 0; i < totalReviewsNo; i++) {
                let newPosition = this.reviews[i].order + movePosition;

                if ((totalReviewsNo > 5 && newPosition < 0) || newPosition < 1) {
                    newPosition = totalReviewsNo + newPosition;
                }
                if (newPosition > totalReviewsNo) {
                    newPosition = newPosition - totalReviewsNo;
                }

                this.reviews[i].order = newPosition;
            }
        }
    },

    mounted() {
        this.axios.get('/api/product')
            .then(response => {
                this.products = response.data
            })
            .catch(e => {
                this.errors.push(e)
            });

        this.axios.get('/api/testimonials')
            .then(response => {

                response.data.data.forEach((v, i) => {
                    v.order = i + 1;
                });

                this.reviews = response.data.data;

            })
            .catch(e => {
                this.errors.push(e)
            });
    }
}
</script>

<style lang="scss" scoped>
    @import 'products.scss'
</style>



// WEBPACK FOOTER //
// src/components/pages/products/products.vue